import React, { useState } from "react";
import { Card, Badge, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import {
  DataTableHead,
  DataTableRow,
  DataTableItem,
  UserAvatar,
  PaginationComponent,
  DataTable,
  Button,
  Icon,
  DataTableBody,
  PreviewAltCard,
} from "../../../Component";
import { recentOrderData } from "./OrderData";
import { BASE_URL_IMG, RUPEES_SYMBOL } from "../../../../assets/constants";
import MyLoader from "../../../../MyComp/UI/form/MyLoader";
import CancelOrderModal from "../../../../MyComp/UI/modals/CancelOrderModal";
import { UserAvatarCell } from "../../../../MyComp/ImageView/UserAvatarCell";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

const PharmacyOrder = ({
  data,
  isLoading,
  paginate,
  currentPage,
  itemPerPage,
  limit,
  setonSearch,
  onSearch,
  setSearchText,
  onSearchText,
  setItemPerPage,
  onOrderClick,
  onViewClick,
  toggleCancelOrder,
  noPagination,
  title,
  updateOrderStatus,
  isOpen,
  selectedRow,
  setIsOpen,
  setSelectedRow,
  hideDeliveryBoyInfo = false,
  isTelecaller = false,
}) => {
  // onChange function for searching name
  const onFilterChange = (e) => {
    setSearchText(e.target.value);
  };

  const updateOrder = (data) => {
    setIsOpen(true);
    setSelectedRow(data);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      <DataTable className={"card-stretch"}>
        <div className="card-inner">
          <div className="card-title-group">
            <div className="card-title">
              <h5 className="title">{title}</h5>
            </div>
            <div className="card-tools me-n1">
              <ul className="btn-toolbar gx-1">
                <li>
                  <Button
                    href="#search"
                    onClick={(ev) => {
                      ev.preventDefault();
                      setonSearch(true);
                    }}
                    className="btn-icon search-toggle toggle-search"
                  >
                    <Icon name="search"></Icon>
                  </Button>
                </li>
                <li className="btn-toolbar-sep"></li>
                <li>
                  <UncontrolledDropdown>
                    <DropdownToggle tag="a" className="btn btn-trigger btn-icon dropdown-toggle">
                      <Icon name="setting"></Icon>
                    </DropdownToggle>
                    <DropdownMenu end className="dropdown-menu-xs">
                      <ul className="link-check">
                        <li>
                          <span>Show</span>
                        </li>
                        {[10, 20, 30, 50, 100].map((num) => (
                          <li key={num}>
                            <DropdownItem
                              className={`dropdown-item ${itemPerPage === num ? "active" : ""}`}
                              href="#dropdownitem"
                              onClick={() => setItemPerPage(num)}
                            >
                              {num}
                            </DropdownItem>
                          </li>
                        ))}
                      </ul>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </li>
              </ul>
            </div>
            <div className={`card-search search-wrap ${onSearch && "active"}`}>
              <div className="search-content">
                <Button
                  onClick={() => {
                    setSearchText("");
                    setonSearch(false);
                  }}
                  className="search-back btn-icon toggle-search"
                >
                  <Icon name="arrow-left"></Icon>
                </Button>
                <input
                  type="text"
                  className="border-transparent form-focus-none form-control"
                  placeholder="Search..."
                  value={onSearchText}
                  onChange={(e) => onFilterChange(e)}
                />
                <Button className="search-submit btn-icon">
                  <Icon name="search"></Icon>
                </Button>
              </div>
            </div>
          </div>
        </div>

        <DataTableBody bodyclass="nk-tb-tnx">
          {/* Table Header */}
          <DataTableHead className="nk-tb-item">
            <DataTableRow>
              <span className="fw-bold">Order No.</span>
            </DataTableRow>
            <DataTableRow>
              <span className="fw-bold">Customer</span>
            </DataTableRow>
            <DataTableRow>
              <span className="fw-bold">Date</span>
            </DataTableRow>
            <DataTableRow>
              <span className="fw-bold">Amount</span>
            </DataTableRow>
            <DataTableRow size={"md"}>
              <span className="fw-bold">Address</span>
            </DataTableRow>
            {/* <DataTableRow size={"md"}>
              <span className="fw-bold">Purchased</span>
            </DataTableRow> */}
            <DataTableRow size={"md"}>
              <span className="fw-bold">Pharmacy</span>
            </DataTableRow>
            <DataTableRow>
              <span className="fw-bold">Status</span>
            </DataTableRow>
            {!hideDeliveryBoyInfo && (
              <DataTableRow size={"md"}>
                <span className="fw-bold">DeliveryBoy Info.</span>
              </DataTableRow>
            )}
            {isTelecaller && (
              <DataTableRow size="md">
                <span className="fw-bold">Mobile</span>
              </DataTableRow>
            )}

            {isTelecaller && (
              <DataTableRow size="md">
                <span className="fw-bold">Purchased</span>
              </DataTableRow>
            )}
            {/* <DataTableRow>
              <span className="fw-bold">Action</span>
            </DataTableRow> */}
          </DataTableHead>

          {/* Table Body */}
          {isLoading ? (
            <MyLoader />
          ) : (
            <>
              {data?.length > 0 ? (
                data?.map((item, idx) => (
                  <DataTableItem key={idx}>
                    {/* Order No. Column */}
                    <DataTableRow>
                      {onOrderClick ? (
                        <span className="tb-lead" onClick={() => onOrderClick(item)} style={{ cursor: 'pointer' }}>
                          <a href="#order" onClick={(ev) => ev.preventDefault()}>
                            {item.orderNum || item.order_no || 'N/A'}
                          </a>
                        </span>
                      ) : (
                        <span className="tb-lead">
                          <a href="#order" onClick={(ev) => ev.preventDefault()}>
                            {item.orderNum || item.order_no || 'N/A'}
                          </a>
                        </span>
                      )}
                    </DataTableRow>

                    {/* Customer Column */}
                    <DataTableRow>
                      <div className="user-card d-flex align-items-center">
                        <UserAvatarCell
                          row={item?.user}
                          name={item?.user?.name || item?.customer_name || item?.mobile}
                          image={`${BASE_URL_IMG + (item?.user?.image || '')}`}
                        />

                        <div className="user-name ms-2">
                          {/* Name */}
                          <span className="tb-lead text-capitalize d-block">
                            {item?.user?.name || item?.customer_name || "N/A"}
                          </span>

                          {/* Mobile number */}
                          <span className="text-muted small d-block">
                            {item?.mobile || item?.user?.mobile || ""}
                          </span>
                        </div>
                      </div>
                    </DataTableRow>

                    {/* Date Column */}
                    <DataTableRow>
                      <span className="tb-sub">{item?.date || item?.order_date || 'N/A'}</span>
                    </DataTableRow>

                    {/* Amount Column */}
                    <DataTableRow>
                      <span className="tb-sub tb-amount">
                        {RUPEES_SYMBOL} {item?.totalAmount || item?.amount || 0}
                      </span>
                    </DataTableRow>

                    {/* Address Column */}
                    <DataTableRow size="md">
                      <span className="tb-sub">{item?.address || item?.delivery_address || 'N/A'}</span>
                    </DataTableRow>

                    {/* Purchased Column */}
                    {/* <DataTableRow size="md">
                      <span className="tb-sub">{item?.purchased || item?.items_count || 0} items</span>
                    </DataTableRow> */}

                    {/* Pharmacy Column */}
                    <DataTableRow size="md">
                      <span className="tb-sub">{item?.pharmacy_name || item?.pharmacy?.name || 'N/A'}</span>
                    </DataTableRow>


                    {/* Status Column */}
                    <DataTableRow>
                      <Badge
                        className="badge-dot badge-dot-xs text-capitalize"
                        color={
                          item?.status === "paid" ||
                            item?.status === "delivered" ||
                            item?.status === "confirmed"
                            ? "success"
                            : item?.status === "processing" ||
                              item?.status === "shipped" ||
                              item?.status === "out_for_delivery"
                              ? "warning"
                              : "danger"
                        }
                      >
                        {item?.status || "pending"}
                      </Badge>
                    </DataTableRow>
                    {!hideDeliveryBoyInfo && (
                      <DataTableRow size="md">
                        <span className="tb-sub">{item?.deliveryBoy_info || item?.deliveryBoy_info || 'N/A'}</span>
                      </DataTableRow>
                    )}
                    {isTelecaller && (
                      <DataTableRow size="md">
                        <span className="tb-sub">{item?.mobile || "N/A"}</span>
                      </DataTableRow>
                    )}

                    {isTelecaller && (
                      <DataTableRow size="md">
                        <span className="tb-sub">{item?.purchased || "N/A"}</span>
                      </DataTableRow>
                    )}

                    {/* Action Column */}
                    {/* <DataTableRow>
                      {item?.status === "pending" && (
                        <div className="d-flex flex-wrap justify-content-start align-items-center">
                         
                          <Button
                            color="primary"
                            title="Nearby Pharmacy"
                            size="xs"
                            className="me-1"
                            onClick={() => onViewClick && onViewClick(item)}
                          >
                            <Icon name="eye"></Icon>
                          </Button>
                        </div>)}
                    </DataTableRow> */}
                  </DataTableItem>
                ))
              ) : (
                <DataTableItem>
                  {/* <DataTableRow colSpan={9} className="text-center">
                    <span className="text-muted">No orders found</span>
                  </DataTableRow> */}
                </DataTableItem>
              )}
            </>
          )}
        </DataTableBody>

        {/* Pagination */}
        {!noPagination && (
          <PreviewAltCard>
            {data?.length > 0 ? (
              <PaginationComponent
                itemPerPage={itemPerPage}
                totalItems={limit}
                paginate={paginate}
                currentPage={currentPage}
              />
            ) : (
              <div className="text-center">
                <span className="text-silent">No orders found</span>
              </div>
            )}
          </PreviewAltCard>
        )}
      </DataTable>

      {/* Update Order Status Modal */}
      <Modal isOpen={isOpen} toggle={handleClose} centered>
        <ModalHeader toggle={handleClose}>Update Order Status</ModalHeader>
        <ModalBody>
          <p className="mb-0">
            Are you sure you want to update the order status of{" "}
            <strong>Order #{selectedRow?.orderNum || selectedRow?.order_no} </strong> to{" "}
            <strong>
              {selectedRow?.status === "processing" && "Shipped"}
              {selectedRow?.status === "shipped" && "Out for Delivery"}
              {selectedRow?.status === "out_for_delivery" && "Delivered"}
              {!["processing", "shipped", "out_for_delivery"].includes(selectedRow?.status) && "Next Status"}
            </strong>{" "}
            placed by <strong>{selectedRow?.user?.name || selectedRow?.customer_name || selectedRow?.address?.full_name}</strong>?
          </p>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={handleClose}>
            No
          </Button>
          <Button color="danger" onClick={() => updateOrderStatus(selectedRow)}>
            Yes, Update Order
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default PharmacyOrder;